import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {AlertService} from '../../../../services/notify/alert.service';
import {HelpersService} from '../../../../services/helpers.service';
import {ModalService} from '../../../../services/modal/modal.service';
import {UsersMultiselectSync} from './users-multiselect.sync';
import {MemberService} from '../../../../services/member.service';

@Component({
    selector: 'app-component-users-multiselect',
    templateUrl: './users-multiselect.component.html',
    styleUrls: ['./users-multiselect.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1, 'margin-top': '0px'})),
            transition(':enter', [style({opacity: 0, 'margin-top': '-15px'}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0, 'margin-top': '-15px'})))
        ])
    ]
})
export class UsersMultiselectComponent implements OnInit, OnDestroy, OnChanges {
    public row: any = [];
    public row2: any = [];
    @Input('sendObject') public sendObject: boolean = false;
    @Input('sendEmail') public sendEmail: boolean = false;
    @Output('value') public value: EventEmitter<any> = new EventEmitter<any>();
    query: FormControl = new FormControl('');
    subscription: Subscription = new Subscription();
    selected = [];
    users: any = [];
    filteredUsers: any = [];
    filteredUsersCopy: any = [];
    isSelectListShow = false;
    public invite_list = [];
    public subs = [];
    public is_crypto = false;
    @Input('onlyCrypto') public onlyCrypto = false;
    @Input() typeSelect = 'multi'; // 'multi' / 'one'
    @ViewChild('select_body') private select_body: ElementRef;
    @ViewChild('select_header') private select_header: ElementRef;

    constructor(
        private alert: AlertService,
        public helper: HelpersService,
        private modalService: ModalService,
        private usersMultiselectSync: UsersMultiselectSync,
        protected memberService: MemberService,
    ) {
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event): void {
        if (
            this.select_body &&
            this.select_header &&
            !this.select_body.nativeElement.contains(event.target) &&
            !this.select_header.nativeElement.contains(event.target)
        ) {
            this.isSelectListShow = false;
        }
    }

    ngOnInit(): void {
        this.getUsers();
        this.filteredUsers = this.row.filter(x => x.has_crypto === this.onlyCrypto);
        this.subs.push(
            this.usersMultiselectSync.syncUsers().subscribe(data => {
                this.getUsers();
                this.query.setValue('');
            })
        );
        this.subscription = this.query.valueChanges
            .subscribe(next => {
                this.searchDepartment(next);
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selected = [];
        this.value.emit(this.selected);
        for (const item of this.filteredUsers) {
            item.selected = false;
        }
        if (changes.onlyCrypto.currentValue) {
            this.filteredUsers = this.row.filter(x => {
                return x.has_crypto === changes.onlyCrypto.currentValue
            });
        } else {
            this.filteredUsers = this.row;
        }
    }

    ngOnDestroy(): void {
        for (const item of this.subs) {
            item.unsubscribe();
        }
        this.subscription.unsubscribe();
    }

    selectItems(item): void {
        if (this.typeSelect === 'one') {
            if (this.selected.length) {
                this.selected[0].selected = false;
            }
            item.selected = true;
            this.selected = [item];

            this.isSelectListShow = false;
            this.emitData();
        } else {
            let next = false;
            if (this.selected.length) {
                this.selected.forEach((value, index) => {
                    if (item.guid === value.guid) {
                        this.selected.splice(index, 1);
                        item.selected = false;
                        next = true;
                        this.emitData();
                    }
                });
            }

            if (!next) {
                item.selected = true;
                this.selected.push(item);

                if (this.filteredUsers.length <= this.selected.length) {
                    this.isSelectListShow = false;
                }

                this.emitData();
            }
        }
    }

    // TODO СТАБИЛИЗИРОВАТЬ РАБОТУ С ИВАЙТАМИ И ЛИМИТОМ МУЛЬТИСЕЛЕКТА
    searchDepartment(e): void {
        if (!e) {
            this.row = this.users;
            this.filteredUsers = this.users.filter(x => x.has_crypto === (this.onlyCrypto || false));
        }
        if (this.users.length && e) {
            this.row = this.users.filter(x => {
                const fullName = x.firstname + ' ' + x.lastname + ' ' + x.middlename;
                const assotiations = (data, searchFromStart = false) => {
                    if (searchFromStart) {
                        return data.toLowerCase().indexOf(e.toLowerCase()) === 0;
                    }
                    return data.toLowerCase().indexOf(e.toLowerCase()) > -1;
                };
                if (
                    assotiations(fullName) ||
                    (x.email && assotiations(x.email, true)) ||
                    (x.phone && assotiations(x.phone, true))
                ) {
                    return x;
                }
            });
            this.filteredUsers = this.users.filter(x => {
                const fullName = x.firstname + ' ' + x.lastname + ' ' + x.middlename;
                const assotiations = (data, searchFromStart = false) => {
                    if (searchFromStart) {
                        return data.toLowerCase().indexOf(e.toLowerCase()) === 0;
                    }
                    return data.toLowerCase().indexOf(e.toLowerCase()) > -1;
                };
                if (
                    (assotiations(fullName) ||
                        (x.email && assotiations(x.email, true)) ||
                        (x.phone && assotiations(x.phone, true))) && x.has_crypto === this.onlyCrypto
                ) {
                    return x;
                }
            });
        }
        if (this.invite_list.length) {
            this.row2 = this.invite_list.filter(x => {
                if (x.email.toLowerCase().indexOf(e.toLowerCase()) > -1) {
                    return x;
                }
            });
        } else {
            this.row2 = [];
        }
    }

    getUsers(): void {
        this.memberService.getAllMembers().then((result: any) => {
            if (this.selected.length) {
                const selectedIds = this.selected.map(x => x.guid);
                for (const item of result.users) {
                    if (selectedIds.includes(item.guid)) {
                        item.selected = true;
                    }
                }
                this.users = this.filteredUsers = this.row = result.filter(x => x.project_setting.observation_type !== 'blocked');
            } else {
                this.users = this.filteredUsers = this.row = result.filter(x => x.project_setting.observation_type !== 'blocked');
            }
        });
    }

    selectedRow(): string {
        const users: any = this.selected.map(x => {
            return (x.firstname && x.lastname) ? x.lastname + ' ' + x.firstname : x.email;
        });
        const emails = this.invite_list.map(x => {
            return x.email;
        });
        if (emails.length) {
            users.push(emails);
        }
        return '<b>' + users.join(", ") + '</b>';
    }

    emitData(): void {
        let data: any;
        if (this.sendObject) {
            data = {
                users: this.selected.map(x => x.guid)
            };
            if (this.invite_list.length) {
                data.invites = this.invite_list;
            }
        } else if (this.sendEmail) {
            data = this.selected.map(x => x.email);
        } else {
            data = this.selected.map(x => x.guid);
            data = data.concat(this.invite_list.map(x => x.email));
        }
        this.value.emit(data);
    }

    removeEmail(index): void {
        const deletion = this.invite_list.splice(index, 1);
        this.inviteListAction({
            data: index,
            action: 'remove'
        });
        this.searchDepartment(this.query.value);
    }

    validateEmail(email): boolean {
        const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return re.test(String(email).toLowerCase());
    }

    selectedValueByInvited(item, control, val): void {
        item.formGroup.controls[control].setValue(val);
    }

    inviteListAction(e): void {
        if (e.action === 'add') {
            e.data.opened = true;
            e.data.completed = false;
            e.data.formGroup = new FormGroup({
                observ: new FormControl('', Validators.required),
                position: new FormControl('')
            });
            this.invite_list.push(e.data);
            this.subs.push(
                e.data.formGroup.valueChanges.subscribe(data => {
                })
            );
        }
        if (e.action === 'remove') {
            this.invite_list.splice(e.data, 1);
        }
        this.emitData();
    }

    completeInvite(item): void {
        item.completed = !item.completed;
        if (item.completed) {
            item.opened = false;
        }
        this.emitData();
    }
}
